module.exports = __webpack_public_path__ + "static/img/mainLogo.a642cea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mainLogo.png
// module id = pPcL
// module chunks = 1